import { useQuery } from '@tanstack/react-query';
import type { UserSummary } from '@motoschool/shared';
import { LESSON_MINUTES_OPTIONS } from '@motoschool/shared';
import { api } from './api';

export interface TeacherOption extends UserSummary {
  hourlyRateMinor: number | null;
}

/**
 * Список активных инструкторов. Нужен и в форме создания окна,
 * и в фильтре расписания, поэтому вынесен в общий хук — запрос
 * кешируется react-query и не повторяется на каждой странице.
 */
export function useTeachers(enabled = true) {
  return useQuery({
    queryKey: ['teachers'],
    queryFn: () => api.get<{ items: TeacherOption[] }>('/users/teachers'),
    enabled,
    staleTime: 5 * 60_000,
  });
}

/**
 * Подписи к длительностям занятия. Сам список минут живёт в общем пакете:
 * по нему же сервер проверяет заявку, и разъехаться они не должны.
 */
export const LESSON_DURATIONS = LESSON_MINUTES_OPTIONS.map((value) => ({
  value,
  label: lessonDurationLabel(value),
}));

/** «1 ч», «1,5 ч», «2 ч» — часы с запятой, как принято в русском. */
export function lessonDurationLabel(minutes: number): string {
  const hours = minutes / 60;
  return `${Number.isInteger(hours) ? hours : String(hours).replace('.', ',')} ч`;
}
